const FEEDBACK_RESERVED_SEGMENTS = new Set(['categories', 'statistics', 'new', 'tasks']);

/**
 * Returns true when the current location matches a sidebar route.
 * Feedback sub-routes (/feedbacks/categories, /feedbacks/statistics) must not
 * highlight the main feedback list item (/feedbacks).
 */
export function isSidebarRouteActive(pathname: string, path: string): boolean {
  const exactMatchRoutes = [
    '/apartments',
    '/apartments/residents',
    '/apartments/monthly-vehicles',
    '/apartments/card-management',
    '/apartments/groups',
    '/apartments/usage-types',
    '/feedbacks/categories',
    '/feedbacks/statistics',
  ];

  if (exactMatchRoutes.includes(path)) {
    return pathname === path;
  }

  if (path === '/feedbacks') {
    if (pathname === '/feedbacks') return true;
    const match = pathname.match(/^\/feedbacks\/([^/]+)$/);
    if (!match) return false;
    return !FEEDBACK_RESERVED_SEGMENTS.has(match[1]);
  }

  return pathname === path || pathname.startsWith(`${path}/`);
}
